import {EventEmitter, Injectable} from '@angular/core';
import {OrdersService} from './orders.service';
import {ReferralsService} from './referrals.service';
import {RoleService} from '../../services/role.service';
import {ToastService} from 'angular-toastify';

@Injectable({
  providedIn: 'root'
})
export class OrdersBadgeService {

  public numQueuedForExtensionChanged$: EventEmitter<number>;
  public numQueuedForConversionChanged$: EventEmitter<number>;
  public numExportableOrdersChanged$: EventEmitter<number>;
  public numReferralsPendingBonusChanged$: EventEmitter<number>;
  constructor(
    private ordersService: OrdersService,
    private referralsService: ReferralsService,
    private roleService: RoleService,
    private _toastService: ToastService,
  ) {

    this.numQueuedForExtensionChanged$ = new EventEmitter();
    this.numQueuedForConversionChanged$ = new EventEmitter();
    this.numExportableOrdersChanged$ = new EventEmitter();
    this.numReferralsPendingBonusChanged$ = new EventEmitter();

  }

  public numQueuedForConversion: number|null = null;
  public numQueuedForExtension: number|null = null;
  public numExportableOrders: number|null = null;
  public numReferralsPendingBonus: number|null = null;


  currentUserIsPartner() {
    return this.roleService.hasRoles(['partner', 'partner_support']);
  }

  currentUserIsAdmin() {
    return this.roleService.hasRoles(['admin']);
  }

  getValues() {
    if (!this.currentUserIsPartner()) {
      if ( this.numReferralsPendingBonus == null ) {
        this.referralsService.getPendingCount().subscribe(i => {
          this.numReferralsPendingBonus = i;
          this.numReferralsPendingBonusChanged$.emit(i);
        });
      }
    }

    if (this.currentUserIsAdmin()) {
      if ( this.numQueuedForExtension == null ) {
        this.ordersService.getCardsQueuedForConversionCount().subscribe(numberOfCards => {
          this.numQueuedForConversion = numberOfCards;
          this.numQueuedForConversionChanged$.emit(numberOfCards ?? 0);
        }, err => {
          this._toastService.error(err.error.message || err.error || err.message);
        });
      }

      if ( this.numQueuedForExtension == null ) {
        this.ordersService.getCardsQueuedForExtension().subscribe(cardExtensions => {
          this.numQueuedForExtension = cardExtensions?.length;
          this.numQueuedForExtensionChanged$.emit(cardExtensions?.length ?? 0);
        }, err => {
          this._toastService.error(err.error.message || err.error || err.message);
        });

      }

      if ( this.numExportableOrders == null ) {
        this.ordersService.getExportableOrdersCount().subscribe(count => {
          this.numExportableOrders = count;
          this.numExportableOrdersChanged$.emit(count);
        }, err => {
          this._toastService.error(err.error.message || err.error || err.message);
        });
      }

    }
  }

  clearCache() {
    this.numQueuedForExtension = null;
    this.numExportableOrders = null;
    this.numQueuedForConversion = null;
    this.numReferralsPendingBonus = null;
    this.getValues();
  }

}
